'use client';

import clsx from 'clsx';
import { SportsOrderItem } from './sports-order-item';
import { useCurrentProperties, useCurrentSportMenuItems, useCurrentSubMenuItems } from '@/hooks/query';
import { useTranslations } from 'next-intl';
import { Button } from '@nf/ui';
import { CloseBigIcon } from '@/components/icons/svg-icons';
import { sportMenuStyle } from '../../sports-menu.style';
import { useSiteStore } from '@/store/site';
import { isVirtualSports } from '@/services/settings.service';
import { useAccountInfo } from '@/hooks/query/account';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';

type SportsOrderProps = {
	handleClose?: () => void,
}

export const SportsOrder = ({ handleClose }: SportsOrderProps) => {
	const { sport } = useCurrentProperties();
	const { user } = useAccountInfo();
	const isParlayMode = useSiteStore(state => state.isParlayMode);
	const currentSportMenuItems = useCurrentSportMenuItems(isParlayMode);
	const subMenuItemsOfCurrentSport = useCurrentSubMenuItems(isParlayMode);
	const t = useTranslations('General');
	// 因left menu的virtual sport 生成為子選單的形式, 因此在這邊用isVirtualSports來判斷要拿一般menu 或是 subMenu 的資料
	const menuItems = !isVirtualSports(Number(sport)) ? currentSportMenuItems : subMenuItemsOfCurrentSport;
	const view = useAppearanceStore(state => state.view);

	// VirtualSport有賽事時才加入VSTournament
	if (user?.VSTournament
		&& user?.ActStatus == 2
		&& isVirtualSports(Number(sport))
		&& menuItems?.length > 0) {
		menuItems.unshift({
			'hasLive': false,
			'name': t('lbl_VSTournament'),
			'icon': 'virtual-tournament',
			'href': '/third-party/vs-tournament',
			'gameId': '',
			'matchCount': 0,
			'isVirtualTournament': true,
		});
	}
	
	return (
		<>
			<div className={clsx('sports-order', sportMenuStyle.sportsOrder)}>
				<div className={clsx('sports-order__title', sportMenuStyle.sportsOrder_title)}>
					{view === ViewEnum.galaxy && isVirtualSports(Number(sport)) ? t('lbl_VirtualSport') : t('lbl_SportsParty_Lic')}
					<Button variant="icon" className={sportMenuStyle.closeButton} onClick={handleClose}>
						<CloseBigIcon />
					</Button>
				</div>
				<div className={clsx('sports-order__list', sportMenuStyle.sportsOrder_list)}>
					{menuItems ? (
						<SportsOrderItem menuList={menuItems} />
					) : null}
				</div>
			</div>
		</>
	);
};